import React, { useEffect, useState } from 'react';
import {
  getSubscriptionState,
  enableWebPush,
  disableWebPush,
} from '../services/webPush';

// Toggle za web-push obvestila (PWA / iOS "Dodaj na začetni zaslon").
// Ponovno uporabna komponenta — vstavi kamorkoli za prijavljenega uporabnika.
export default function EnableNotifications() {
  const [state, setState] = useState('loading'); // loading|unsupported|denied|subscribed|default
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    getSubscriptionState().then(setState).catch(() => setState('unsupported'));
  }, []);

  if (state === 'loading' || state === 'unsupported') return null;

  const toggle = async () => {
    setBusy(true);
    setMsg('');
    try {
      if (state === 'subscribed') {
        await disableWebPush();
        setState('default');
      } else {
        await enableWebPush();
        setState('subscribed');
        setMsg('Obvestila vklopljena ✓');
      }
    } catch (e) {
      setMsg(e.message || 'Napaka');
    } finally {
      setBusy(false);
    }
  };

  const label =
    state === 'subscribed' ? '🔕 Izklopi obvestila' : '🔔 Vklopi obvestila v brskalniku';

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
      <button
        type="button"
        onClick={toggle}
        disabled={busy || state === 'denied'}
        className="btn"
        style={{ padding: '6px 12px', borderRadius: 8, cursor: state === 'denied' ? 'not-allowed' : 'pointer' }}
      >
        {busy ? '…' : label}
      </button>
      {state === 'denied' && (
        <span style={{ fontSize: 12, color: '#c00' }}>Obvestila so blokirana v nastavitvah brskalnika.</span>
      )}
      {msg && <span style={{ fontSize: 12, color: msg.includes('✓') ? '#0a0' : '#c00' }}>{msg}</span>}
    </span>
  );
}
